import { use, useEffect } from 'react'
import type { CustomReportDataProvider } from '#features/Feedback/buildReport'
import { InternalCustomerReportContext } from './InternalCustomerReportContext'

export const useRegisterCustomReportData = (provider: CustomReportDataProvider) => {
  const context = use(InternalCustomerReportContext)
  if (!context) {
    throw new Error('useRegisterCustomReportData must be used within a CustomReportDataContext')
  }

  useEffect(() => {
    context.reportDataProviders?.add(provider)
    return () => {
      context.reportDataProviders?.delete(provider)
    }
  }, [context, provider])
}
